(function($, undefined) {
	
	'use strict';
	var explanationList;
	var explanationForm;
	var formValidator;
	
	var submitExplanationForm = function() {
		var form = $(this).closest('form');
		form.addClass('processing');
		formValidator.validateForm(form);
		
		if (!form.hasClass('has-error')) {
			var name = $('[name=data-name]', form).length > 0 ? $('[name=data-name]', form).val() : null;
			var explanationTextarea = $('[name=field4]', form);
			var explanationText = explanationTextarea.length > 0 ? tinymce.get(explanationTextarea.attr('id')).getContent() : null;
			var id = $('[name=id]', form).val();
			
			var action = "/action/manageGenData";
			var params = {
				ajax: true,
				field1: 'explanation',
				field3: $('[name=field3]', form).val(),
				field4: explanationText
			};
			if (name) {
				params.field2 = name;
			}
			if (id) {
				params.id = id;
			}
			$.ajax({
				url: action,
				method: "post",
				data: params,
				complete: function(response) {
					console.log(response.responseText);
					console.log(params);
					if (response.responseText.indexOf('success') !== -1) {
						location.reload();
					} else {
						form.removeClass('processing');
					}
				}
			});
		} 
		else {
			form.removeClass('processing');
		}
	};
	
	var init = function () {
		formValidator = Fw.component.models().form;
		explanationForm = $('.explanation-admin-form');
		
		$('.save-explanation-btn', explanationForm).on('click', submitExplanationForm);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
